import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}





function Models(prop) {

    var global = window.GlobalVars;
    var tab;

	function editModel( model, add )
	{
		console.log( 'editModel', model, add )
		if( add ) {
			window.GlobalVars.ModelId = null;
			window.GlobalVars.ModelCompany = null;
		}
		else {
			window.GlobalVars.ModelId = model.id;
			window.GlobalVars.ModelCompany = model.company;
		}
		window.saveSession( function(){
			window.goPage('modeledit');
		});
		
		return;
		// var origModel = clone(model);
		// model.newname = model.name;
	    // function cb(ev)
	    // {
		// 	if( !model.newname || !model.newname.trim() ) { alert( 'Model Name is required' ); return false; }
		// 	var updateData = {
		// 		_new: add || false,
		// 		_id: model._id,
		// 		name: model.newname,
		// 		registername: model.registername,
		// 		priv: model.priv,
		// 		active: model.active ? true : false,
		// 	};
		// 	console.log( 'UPDATE_COMPANY', updateData );
	    //     window.post( 'update_model', {model:updateData}, function(res){
	    //         // console.log( 'UPDATE USER', res )
	    //         if( res.data.status )
	    //         {
		// 			setTimeout( function(){document.location.reload();},200 );
	    //         }
	    //         else
		// 		{
		// 			alert( res.data.value );
		// 		}
	    //     });
		// 	return false;
	    // }
		// if( Date.now() > model.resetTimeout ) model.resetPassword = null;
		// var content = `
		// <div id="modeldetails">
		// <label for="name">Model Name</label>
		// <input placeholder="Model Name" type="text" id="newname" class="mb-4 form-control">
		// <input placeholder="Business Legal Name" type="text" id="registername" class="mb-4 form-control">
		// <div id="modelActive"></div>
		// <div id="modelPrivs"></div>
		// </div>
		// `;

		// function changed()
		// {
		// }

		// function close()
		// {

		// }
		// var btnName = add ? 'Add Model' : 'Update Model';
		// var title = add ? 'Add New Model' : 'Edit Model';
		// frm.myAlert( title, content, btnName, cb, 'Cancel', close );

		// setTimeout( function(){
		// 	focus.focus();
		// }, 500);

		// ['newname','registername'].forEach( n =>
		// {
		// 	$('#modeldetails').find('#'+n).val( model[n] ).on('change', function(){
		// 		var id = $(this).prop('id');
		// 		var val = $(this).val();
		// 		console.log( 'change', id, val );
		// 		model[id] = val;
		// 		changed();
		// 	})
		// })
		// var focus = $('#name');

		// // frm.booleanList( $('#modelActive'), model)
		// frm.booleanList( $('#modelActive'), model, {
		// 	items: {
		// 		'active': { default: false, label: 'Model Active' },
		// 	},
		// 	callbackOnInit: false,
		// }, function(o){
		// 	model.active = o.active;
		// 	changed()
		// });

		// var modelPrivs = frm.arr2Bool(model.priv.split(','));
		// var privItems = {};
		// var allPrivs = clone(window.privs); delete allPrivs.admin;
		// for( var p in allPrivs ) privItems[p] = { default: false, label: window.privs[p] };
		// console.log( modelPrivs, privItems );
		// frm.booleanList( $('#modelPrivs'), modelPrivs, {
		// 	items: privItems,
		// 	header: ['','Privileges'],
		// 	callbackOnInit: false,
		// }, function(o){
		// 	var npriv = [];
		// 	for( var p in o ) if(o[p]) npriv.push(p);
		// 	model.priv = npriv.join(',');
		// 	console.log( 'privs', o, model.priv );
		// 	changed();
		// } );
	    // return false;
	}





    useEffect( function(a){
        $('#topbuttons').html('');

		var addModelBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary"><i class="fa fa-plus mr-2"></i>Add Model</Button>')
		addModelBut.on('click', () => {
			editModel( {active:true,priv:''}, 1 );
		})
		$('#topbuttons').append(addModelBut);
		var modelSelect = window.GlobalVars.modelProjectSelect == 1;
		if( modelSelect )
		{
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 ml-2 btn btn-secondary"><i class="fa fa-plus mr-2"></i>Add Selected Models to Project<span class="selcount"></span></Button>')
			$('#topbuttons').append(projBut);
			projBut.on('click', function(){
				if( Object.keys(window.GlobalVars.modelTableCtx.selected) == 0 )
				{
					// return frm.myAlert( '', 'Please select models to be added to the project' );
				}
				else
					window.GlobalVars.modelProjectSelect = 2;
				window.saveSession();
				window.goPage('nlpWorkers');
			})
		}
		else {
			// window.GlobalVars.modelTableCtx = {};
		}


        var match = {};
		window.post( 'find_models', {match:match}, function(res){
			console.log( 'models', res.data );
			var models = res.data.records;
			if( !models.length )
			{
				$('.alert').remove();
				var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No models found');
				$('#topbuttons').prepend(empty);
				$('#documentlist').hide();
			}
            var desc = {
				selectMode: modelSelect,
				selectId: 'email',
                title: 'Model Management',
                columns: {
	                // _id: 'Id',
                    name: 'Name',
					companyName: 'Company',
                    type: 'Model Type',
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                initialSort: 'name',
                initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: ['instanceType','instanceCount'],
				format: tabler.formatString,
				formatCol: {
					type: function(v) { return window.modelTypes[v] }
					// lastLogin:tabler.formatTimeAgo,
					// created:tabler.formatDate,
					// priv:tabler.formatPriv,
					// active: tabler.formatActive,
				},
				forceType:{ created: 1 },
				headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            tab = tabler.table($('#documentlist'), desc, 'models' );
            models.forEach( a => {
                a.stateLabel = '<span class="state_'+a.state+'">' + a.stateLabel + '</span>';
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler click', a._id, row[col], row )
					editModel( row );
                    // fileClickTabler( col, row )
                })
            });
            tab.draw();
			tab.saveCtx( selCount );
			selCount();
            console.log( 'desc', desc, 'tabler', tabler.formatString )
        });

    });

	function selCount()
	{
		var ctx = tabler.getCtx( 'models' );
		var s = ctx.selected || {};
		$('.selcount').text(' ('+Object.keys(s).length+')')
	}

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="topbuttons"></div>
        <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
        </Table>
        <span>&nbsp;</span>
        </div>
    )
}

export default Models
